import './ShoppingCartView.scss'
import _ from 'lodash'

import React from 'react'
import {Icon, Table, Button, Checkbox, Input, Grid, Header, Modal, Image} from 'semantic-ui-react'
import moment from 'moment'
import CategoryDefaultImage from '../../../assets/category_default_image.png'
import {PAYMENT_STATUS, RECEIPT_STATUS} from '../../../constants'

import CONFIG from '../../../config'
import {STEPS} from "../../../constants";

import {C, getLanguageScope, N, restrictInvalidChars} from '../../../helpers'

const _i18n = getLanguageScope('shopping_cart');

class ShoppingCart extends React.Component {
  constructor(props) {
    super(props);

    this.changeReceivedAmount = this.changeReceivedAmount.bind(this);
  }

  componentDidMount() {
    const {loadProducts, updateCommonReceipt} = this.props;

    updateCommonReceipt(RECEIPT_STATUS.RECEIPT_WAIT_PROCESSING);

    loadProducts && loadProducts();
  }

  addTransaction() {
    const {changeStep} = this.props;

    return changeStep(STEPS.CATEGORIES);
  }

  renderRows() {
    const {payments, selectPayment} = this.props;

    const renderedCustomers = [];

    return _.map(payments, (items, customer_mobile_number) => {
      return (
        _.map(items, (item, key) => {

          const icon = item.icon ? `${CONFIG.STATIC_PATH}${item.icon}` : CategoryDefaultImage;

          return (
            <Table.Row key={key}>
              {!_.includes(renderedCustomers, customer_mobile_number) ?
                (renderedCustomers.push(customer_mobile_number),
                  <Table.Cell rowSpan={items.length}>
                    {customer_mobile_number}
                  </Table.Cell>) : null}
              <Table.Cell positive={item.payment_selected} className='clear-cell' collapsing>
                <Checkbox disabled={item.payment_status !== PAYMENT_STATUS.PAYMENT_WAIT_PROCESSING}
                          onChange={() => selectPayment(item.payment_id)} checked={item.payment_selected}/>
              </Table.Cell>
              <Table.Cell positive={item.payment_selected}>
                <Image inline size='mini' src={icon}/>
                <span style={{paddingLeft: 8}}>{item.name}</span>
              </Table.Cell>
              <Table.Cell positive={item.payment_selected}>{this.renderDetails(item)}</Table.Cell>
              <Table.Cell
                positive={item.payment_selected}>{moment(new Date(item.created_date)).format('lll')}</Table.Cell>
              <Table.Cell positive={item.payment_selected}>{C(item.original_amount, '$')}</Table.Cell>
              <Table.Cell positive={item.payment_selected}>{C(item.fee, '$')}</Table.Cell>
              <Table.Cell textAlign='center' positive={item.payment_selected} collapsing>
                {this.renderAction(item)}
              </Table.Cell>
            </Table.Row>
          )
        })
      );
    })
  }


  renderAction(item) {
    const {selectPaymentOnDelete, printReceipt, have_payment_in_processing} = this.props;

    if (item.payment_status === PAYMENT_STATUS.PAYMENT_WAIT_PROCESSING) {
      return (
        <Button style={{background: 'none'}} onClick={() => selectPaymentOnDelete(item.payment_id)} icon>
          <Icon name='trash alternate outline' size='large'/>
        </Button>
      )
    }

    if (item.payment_status === PAYMENT_STATUS.PAYMENT_IN_PROCESSING) {
      return (
        <Icon loading size='large' name='circle notch'/>
      )
    }

    if (item.payment_status === PAYMENT_STATUS.PAYMENT_SUCCESS) {

      if (item.payment_receipt_url) {
        return (
          <Button disabled={have_payment_in_processing} onClick={() => printReceipt(item.payment_receipt_url)} icon
                  labelPosition='right'>
            {_i18n('print_receipt')}
            <Icon name='right check'/>
          </Button>
        )
      }

      return (
        <Icon size='large' name='check'/>
      )
    }

    if (item.payment_status === PAYMENT_STATUS.PAYMENT_FAIL) {

      if(item.details.payment_error_message){
        return (
          <Header as='р4' color={'red'} icon='close' style={{fontSize: "0.9em"}} content={item.details.payment_error_message} />
        )
      }

      return (
        <Icon color='red' size='large' name='close'/>
      )
    }
  }

  renderDetails(item) {
    if (!item.details) return null;

    return (
      <Grid>
        {item.details.account ?
          <React.Fragment>
            <Grid.Row>
              <Grid.Column>
                {`${_i18n('account')}:`} <br/>
                {item.details.account}
              </Grid.Column>
            </Grid.Row>
          </React.Fragment>
          : null}

        {item.details.card_parsed_account ?
          <React.Fragment>
            <Grid.Row>
              <Grid.Column>
                {`${_i18n('card_number')}:`} <br/>
                {item.details.card_parsed_account}
              </Grid.Column>
            </Grid.Row>
          </React.Fragment>
          : null}
      </Grid>
    );
  }

  renderGeneralReceipt() {
    const {
      receipt_button_show, receipt_button_loading, receipt_button_success, receipt_button_disabled, receipt_url,
      printReceipt
    } = this.props;

    if (!receipt_button_show) return null;

    return (
      <Grid.Row>
        <Grid.Column className='flex-in-end' size={16}>
          <Button loading={receipt_button_loading}
                  disabled={receipt_button_disabled}
                  color={receipt_button_success ? 'green' : 'grey'}
                  onClick={() => printReceipt(receipt_url)}
                  content={_i18n('print_general_receipt')}
                  icon='right check' labelPosition='right'/>
        </Grid.Column>
      </Grid.Row>
    )
  }

  changeReceivedAmount(value){
    const {total_amount, updateReceivedAmount} = this.props;

    if(value > total_amount + 100) return;

    updateReceivedAmount(value);
  }

  render() {
    const {
      payments, total_amount, change_amount, disabled_input, show_change, disable_pay_button, payment_on_delete, open_modal,
      received_amount, updateReceivedAmount, selectAllPayments, selectPaymentOnDelete, removePayment, startPayPayments
    } = this.props;

    if (_.isEmpty(payments)) {
      return (
        <div>
          <Header as='h3' icon='cart arrow down' content={_i18n('empty_cart')}/>
          <Button onClick={() => this.addTransaction()}>{_i18n('add_transaction')}</Button>
        </div>
      )
    }

    return (
      <div>
        <Table className='table-with-bottom-button' celled compact definition>
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell width={3}>{_i18n('customer')}</Table.HeaderCell>
              <Table.HeaderCell/>
              <Table.HeaderCell width={5}>{_i18n('product_name')}</Table.HeaderCell>
              <Table.HeaderCell>{_i18n('details')}</Table.HeaderCell>
              <Table.HeaderCell width={4}>{_i18n('created_date')}</Table.HeaderCell>
              <Table.HeaderCell width={2}>{_i18n('amount')}</Table.HeaderCell>
              <Table.HeaderCell width={2}>{_i18n('fee')}</Table.HeaderCell>
              <Table.HeaderCell width={1}/>
            </Table.Row>
          </Table.Header>

          <Table.Body>

            {this.renderRows()}

          </Table.Body>

          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell>
              </Table.HeaderCell>
              <Table.HeaderCell colSpan='7'>
                <Grid columns='equal'>
                  <Grid.Row>
                    <Grid.Column floated='left' width={4}>
                      <Button onClick={() => selectAllPayments()} size='small'>
                        {_i18n('select_all')}
                      </Button>
                    </Grid.Column>
                    <Grid.Column width={12} floated='right'>

                      <Grid>

                        <Grid.Row>
                          <Grid.Column mobile={8} tablet={10} computer={13}>
                            <Header floated='right' as={'h4'} content={`${_i18n('total_amount')}:`}/>
                          </Grid.Column>
                          <Grid.Column mobile={8} tablet={6} computer={3}>
                            {C(total_amount, '$')}
                          </Grid.Column>
                        </Grid.Row>


                        {this.renderGeneralReceipt()}

                        {show_change ? <Grid.Row>
                          <Grid.Column mobile={8} tablet={10} computer={13}>
                            <Header floated='right' as={'h4'} content={`${_i18n('change')}:`}/>
                          </Grid.Column>
                          <Grid.Column mobile={8} tablet={6} computer={3}>
                            {C(change_amount, '$')}
                          </Grid.Column>
                        </Grid.Row> : null}

                        <Grid.Row>
                          <Grid.Column className='flex-in-end' width={16}>
                            <Input
                              action={
                                {
                                  color: 'violet',
                                  labelPosition: 'right',
                                  icon: 'cart',
                                  content: _i18n('pay_for_products'),
                                  disabled: disable_pay_button,
                                  onClick: () => startPayPayments()
                                }
                              }
                              placeholder={_i18n('enter_amount_received')}
                              value={received_amount}
                              type={'number'}
                              name={'received_amount'}
                              disabled={disabled_input}
                              onChange={(e, {name, value}) => this.changeReceivedAmount(value)}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>

                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>

          <Modal style={{height: 'auto'}} size={'mini'} open={open_modal} onClose={() => selectPaymentOnDelete()}>
            <Modal.Header>{_i18n('delete_payment')}</Modal.Header>
            <Modal.Content>
              <p>{_i18n('delete_payment_details')}</p>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={() => selectPaymentOnDelete()} negative>{_i18n('no')}</Button>
              <Button onClick={() => removePayment(payment_on_delete)} positive icon='checkmark' labelPosition='right'
                      content={_i18n('yes')}/>
            </Modal.Actions>
          </Modal>

        </Table>
        <Button
          style={{margin: "0px 1px"}}
          attached='bottom'
          color='teal'
          content={_i18n('add_another_transaction')}
          onClick={() => this.addTransaction()}
        />
      </div>

    )

  }
}

ShoppingCart.propTypes = {};

export default ShoppingCart


// WEBPACK FOOTER //
// ./src/components/ShoppingCart/components/ShoppingCartView.js